import { render, staticRenderFns } from "./allQuestions.vue?vue&type=template&id=8a69edba&scoped=true"
import script from "./allQuestions.vue?vue&type=script&lang=js"
export * from "./allQuestions.vue?vue&type=script&lang=js"
import style0 from "./allQuestions.vue?vue&type=style&index=0&id=8a69edba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a69edba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a69edba')) {
      api.createRecord('8a69edba', component.options)
    } else {
      api.reload('8a69edba', component.options)
    }
    module.hot.accept("./allQuestions.vue?vue&type=template&id=8a69edba&scoped=true", function () {
      api.rerender('8a69edba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/allQuestions.vue"
export default component.exports